import { useMemo } from 'react';
import type { ConfigOverride } from '#dn-types/host.ts';
import { CONFIG_OVERRIDE_GROUPS } from '#screens/tags/form/config-overrides/ConfigChooser.tsx';

export const configOverrideOrdering = CONFIG_OVERRIDE_GROUPS.flatMap(([, list]) => list);

/** {@link useSortedConfigOverrides} sorts a list of config overrides into a consistent list, omitting all `stats.{string}` overrides */
export function useSortedConfigOverrides(configOverrides: ConfigOverride[]) {
  return useMemo(() => sortConfigOverrides(configOverrides), [configOverrides]);
}

function sortConfigOverrides(configOverrides: ConfigOverride[]) {
  const sortedConfigOverrides = configOverrideOrdering.flatMap((configOverrideKey) =>
    configOverrides.filter(({ key }) => configOverrideKey === key)
  );

  return sortedConfigOverrides;
}
